import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ContentSchedule } from "entities/contentSchedule/types";
import { updatePageModuleStatus } from "entities/pages/api/updatePageModuleStatus";
import { PageModuleStatus } from "entities/pages/types";
import {
  ALL_BRANDS_MODULES_QUERY_KEY,
  getAllBrandsWithAllModulesQueryData,
  invalidateAllBrandsWithAllModulesQuery,
} from "../queries/useAllBrandsWithAllModulesQuery";

type Params = {
  brandId: string;
  pageId: string;
  moduleId: string;
  status: PageModuleStatus;
};

export const useUpdateContentModuleStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ moduleId, status, brandId, pageId }: Params) => {
      return await updatePageModuleStatus({
        moduleId,
        status,
        brandId,
        pageId,
      });
    },
    onMutate: async ({ moduleId, status, brandId, pageId }: Params) => {
      const previousData = getAllBrandsWithAllModulesQueryData();

      if (previousData) {
        queryClient.setQueryData<ContentSchedule[]>(
          ALL_BRANDS_MODULES_QUERY_KEY,
          (old = []) => {
            return old.map((module) => {
              if (
                module.id === moduleId &&
                module.brandId === brandId &&
                module.pageId === pageId
              ) {
                return { ...module, status };
              }
              return module;
            });
          },
        );
      }

      return { previousData };
    },
    onSuccess: () => {
      invalidateAllBrandsWithAllModulesQuery();
    },
    onError: (_, __, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(
          ALL_BRANDS_MODULES_QUERY_KEY,
          context.previousData,
        );
      }
    },
  });
};
